<template>
  <div>
    <loading-screen v-if="isLoading" />
    <div class="p-6 text-gray-900 bg-white rounded-lg text-left font-medium shadow-lg">
      <h1 class="font-semibold text-xl">
        <fa-icon
          :icon="['fas', 'cog']"
          size="lg"
          class="mr-1 text-blue-400"
        />
        {{ $t("Settings", "Settings") }}
      </h1>
      <div class="mx-48 mt-4 p-4 text-center">
        <subscription
          type="view"
          :subscription="subscription"
        />
        <h1 class="text-xl font-normal mt-6 mb-2">
          {{ $t("Members", "Members") }}
        </h1>
        <div class="w-full flex justify-between">
          <z-input
            v-model="email"
            class="w-3/4"
            placeholder="Email"
            @input="updateEmail($event)"
          />
          <z-button
            type="primary"
            :text="$t('Send invitation', 'Send invitation')"
            :disabled="!isEmailValid"
            @click="sendInvitation()"
          />
        </div>
        <div class="w-full flex border border-gray-400 bg-gray-200 font-normal p-2">
          <div class="w-1/3 text-left">
            {{ $t("Name", "Name") }}
          </div>
          <div class="w-1/3 text-right">
            {{ $t("Email", "Email") }}
          </div>
          <div class="w-1/3 text-right">
            {{ $t("Last seen", "Last seen") }}
          </div>
        </div>
        <div
          v-for="member in members"
          :key="member.id"
        >
          <member :member="member" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { actionNames } from '@/settings/store'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCog } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Subscription from '../global/components/Subscription'
import ZButton from '../global/ui/Button'
import ZInput from '../global/ui/Input'
import Member from './components/Member'
import LoadingScreen from '@/global/ui/LoadingScreen'

library.add(faCog)
export default {
  name: 'Profile',
  components: {
    'fa-icon': FontAwesomeIcon,
    Subscription,
    ZButton,
    ZInput,
    Member,
    LoadingScreen
  },
  data () {
    return {
      email: '',
      reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      isLoading: false
    }
  },
  computed: {
    ...mapState({
      subscription: state => state.profile.subscription,
      members: state => state.profile.members
    }),
    isEmailValid () {
      return this.reg.test(this.email)
    }
  },
  async mounted () {
    this.isLoading = true
    await this.$store.dispatch(actionNames.INIT_SUBSCRIPTION)
    await this.$store.dispatch(actionNames.INIT_MEMBERS)
    this.isLoading = false
  },
  methods: {
    updateEmail (email) {
      this.email = email
    },
    async sendInvitation () {
      try {
        await this.$store.dispatch(actionNames.ADD_MEMBER, this.email)
        this.$toast.success('Invitation successfully sent!')
        this.email = ''
      } catch (e) {
        this.$toast.error('Something went wrong! Please try again later or contact your account manager.')
      }
    }
  }
}
</script>
